/**
 * Achados da triagem (E54.F6.T04, prancha 3A). // ux-neutrality:allow doc-comment
 *
 * A prancha grifa os achados DENTRO do texto da síntese. Não é implementável // ux-neutrality:allow doc-comment
 * com honestidade: a síntese chega do backend como prosa corrida, sem os // ux-neutrality:allow doc-comment
 * intervalos do que deve ser grifado, e casar string produziria destaque no // ux-neutrality:allow doc-comment
 * lugar errado numa tela que o perito usa para decidir se o caso segue. O que // ux-neutrality:allow doc-comment
 * é dado real são as MARCAÇÕES — cada uma já vem rotulada como convergência ou // ux-neutrality:allow doc-comment
 * divergência, com a observação do achado —, e é nelas que o destaque entra. // ux-neutrality:allow doc-comment
 * Divergência deliberada, registrada em docs/design/comparacoes/README.md. // ux-neutrality:allow doc-comment
 *
 * Mesma cor das marcações desenhadas sobre a assinatura (mapa único de sinal, // ux-neutrality:allow doc-comment
 * E54.F5.T01): a lista e o traço concordam por construção. // ux-neutrality:allow doc-comment
 */
import { ptBR } from '@/i18n/pt-BR';
import type { MarcacaoData, MarcacaoRotulo } from '@/lib/pre_analise';

export interface TriagemFindingsProps {
  marcacoes: MarcacaoData[];
}

const _ROTULO_LABEL: Record<MarcacaoRotulo, string> = {
  convergencia: ptBR.preAnalise.marcacaoConvergencia,
  divergencia: ptBR.preAnalise.marcacaoDivergencia,
};

/** Tinta de fundo do destaque, na rampa de sinal do pacote (o `<mark>` da 3A). */
const _ROTULO_MARK: Record<MarcacaoRotulo, string> = {
  convergencia: 'bg-success-50 text-success-700',
  divergencia: 'bg-danger-50 text-danger-700',
};

export function TriagemFindings({ marcacoes }: TriagemFindingsProps): JSX.Element | null {
  if (marcacoes.length === 0) return null;

  return (
    <ul className="mt-sc-4 flex flex-col gap-sc-2" data-testid="pre-analise-achados">
      {marcacoes.map((marcacao, idx) => (
        <li
          key={idx}
          className="flex flex-wrap items-baseline gap-x-sc-2 gap-y-1 text-body-sm text-fg"
          data-testid={`pre-analise-achado-${idx}`}
          data-rotulo={marcacao.rotulo}
        >
          <mark className={`px-1 py-px text-[11px] uppercase ${_ROTULO_MARK[marcacao.rotulo]}`}>
            {_ROTULO_LABEL[marcacao.rotulo]}
          </mark>
          <span>{marcacao.observacao}</span>
        </li>
      ))}
    </ul>
  );
}
